import type { PrintScreenToPDFOrientation } from "./firebase-function-types";

export const defaultOrientation: PrintScreenToPDFOrientation = "portrait";
export const defaultZoomPercentage = 100;
export const minZoomPercentage = 20;
export const maxZoomPercentage = 200;
